<template>
  <wrapper @clear="clear()" :showClear="showClear" :filter="filter">
    <div @click="changeQty()" style="margin-top:15px;">For quantity: <u style="color:red; cursor: pointer">{{ qty }}</u>
    </div>
    <div class="filters__range" v-if="filter.filter.slug === 'price_eu_1'">
      <div class="range__min">
        <input type="text" v-model.lazy="min_value" placeholder="od"/>
      </div>
      <div class="range__separator">-</div>
      <div class="range__max">
        <input type="text" v-model.lazy="max_value" placeholder="do"/>
      </div>
    </div>
  </wrapper>
</template>

<script>
const ranges = [
  [0, 9],
  [10, 19],
  [20, 49],
  [50, 99],
  [100, 199],
  [200, 299],
  [300, 499],
  [500, 999],
  [1000, 1999],
  [2000]
];

import wrapper from "./Wrapper.vue";
import {buildAppUrl} from "../../utils/utils.js";

export default {
  name: "prices",
  components: {
    wrapper: wrapper
  },
  props: {
    filters: Array,
    filter: Object
  },
  data() {
    return {
      min_value: "",
      max_value: "",
      qty: 100
    };
  },
  mounted() {
    let params = new URLSearchParams(window.location.search);
    if (params.get("price_qty")) {
      this.qty = parseInt(params.get("price_qty"));
    }

    if (this.activeFilter.filter.values.min) {
      this.min_value = this.activeFilter.filter.values.min;
    }

    if (this.activeFilter.filter.values.max) {
      this.max_value = this.activeFilter.filter.values.max;
    }
  },
  computed: {
    activeFilter() {
      return Object.values(this.filters).reverse().find(filter => {
        let range = filter.filter.tooltip.match(/^([0-9]*)\-([0-9]*)$/);
        if (range) {
          return parseInt(range[1]) <= parseInt(this.qty);
        }
      });
    },
    showClear() {
      return this.filters
          .filter(a => a.filter.slug.startsWith('price_eu_'))
          .some(a => a.filter.values.min || a.filter.values.max)
    },
  },
  emits: ["change"],
  watch: {
    min_value: function () {
      let values = this.activeFilter.filter.values;
      if (this.min_value && values.min !== this.min_value) {
        values.min = this.min_value;
        this.$emit("change");
      }

      if (!this.min_value && values.min) {
        delete values.min;
        this.$emit("change");
      }
    },
    max_value: function () {
      let values = this.activeFilter.filter.values;
      if (this.max_value && values.max !== this.max_value) {
        values.max = this.max_value;
        this.$emit("change");
      }

      if (!this.max_value && values.max) {
        delete values.max;
        this.$emit("change");
      }
    }
  },
  methods: {
    changeQty() {
      let values = this.activeFilter.filter.values;
      let min = values.min;
      let max = values.max;

      let qty = parseInt(prompt("Qty", this.qty));
      if (Number.isInteger(qty) && qty >= 0) {
        this.qty = qty;

        this.filters
            .filter(a => a.filter.slug.startsWith('price_eu_'))
            .forEach(a => {
              delete a.filter.values.min;
              delete a.filter.values.max;
            });

        this.activeFilter.filter.values.min = min;
        this.activeFilter.filter.values.max = max;
      }

      let params = buildAppUrl(this.filters);
      params.price_qty = this.qty;

      if(params.price_qty == 100) {
        delete params.price_qty;
      }

      this.$router.push({query:params});

      /*let query = (new URLSearchParams(window.location.search));

      query.set("price_qty", this.qty);

      history.pushState(
          {},
          null,
          window.location.pathname +
          (query.toString() ? "?" + query.toString() : "")
      );*/

      this.$emit("change");
    },
    clear() {
      this.filters
          .filter(a => a.filter.slug.startsWith('price_eu_'))
          .forEach(a => {
            delete a.filter.values.min;
            delete a.filter.values.max;
          });

      this.min_value = '';
      this.max_value = '';

      this.$emit('change');
    }
  }
};
</script>
